import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useI18n } from '@/hooks/useI18n';
import { Loader2, WifiOff, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  OfflineItinerariesService,
  OfflineItineraryEntry,
  replaceUrls,
} from '@/services/offline-itineraries.service';
import { SharedProposalView } from '@/lib/shared-proposal/components/SharedProposalView';

const OfflineViewerPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { t } = useI18n();
  const [entry, setEntry] = useState<OfflineItineraryEntry | null>(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!id) { setNotFound(true); return; }
    OfflineItinerariesService.get(id).then((result) => {
      if (result) setEntry(result);
      else setNotFound(true);
    });
  }, [id]);

  if (notFound) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 gap-4">
        <WifiOff className="h-12 w-12 text-gray-300" />
        <p className="text-gray-500">{t('offline.notFound')}</p>
        <Button variant="ghost" onClick={() => navigate('/downloaded')}>
          <ArrowLeft className="h-4 w-4 mr-2" />
          {t('offline.backToDownloaded')}
        </Button>
      </div>
    );
  }

  if (!entry) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-gray-400" />
      </div>
    );
  }

  const itinerary = replaceUrls(entry.data.itinerary, entry.imageCache);
  const sharedBy = replaceUrls(entry.data.sharedBy, entry.imageCache);

  return (
    <SharedProposalView
      itinerary={itinerary}
      sharedBy={sharedBy}
      paymentEnabled={false}
    />
  );
};

export default OfflineViewerPage;
